import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

type ServiceWorkspaceBackLinkProps = {
  label?: string;
  onClick: () => void;
  className?: string;
};

const mergeClassNames = (...parts: Array<string | null | undefined | false>) =>
  parts.filter(Boolean).join(' ');

export const ServiceWorkspaceBackLink: React.FC<ServiceWorkspaceBackLinkProps> = ({
  label = 'Zlecenia serwisu',
  onClick,
  className,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={mergeClassNames(
      'inline-flex min-h-[36px] items-center gap-1.5 rounded-md px-1.5 text-[13px] font-medium text-primary-light-300 transition-colors hover:text-primary-light-100 focus-outline',
      className
    )}
  >
    <ArrowLeftIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
    <span>{label}</span>
  </button>
);

export default ServiceWorkspaceBackLink;
